import React, { Component } from 'react';
class CalendarDates extends Component {
  constructor() {
    super();
    this.state = {
      dates_data:'',
    };
  }


componentDidMount(){
  var dates = this.props.all_dates_data;
  var dates_new = dates['calendar'];
  this.convert_dates(dates_new);
}

convert_dates(dates){
  var week_day_name = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var dates_len = dates.length;
  var dates_data = [];
  for(var i=0; i<dates_len;i++){
    var sub_data = [];
    var sub_array = dates[i];
    for(var j=0; j<sub_array.length;j++){
      var className = '';
      if(sub_array[j]==null){className = 'no_date';}
      var holiday = '';
      if(j==0 && sub_array[j]!=null){holiday='holiday';}
    sub_data.push(<div class={"weekday calendar_heading "+className+" "+holiday}>{sub_array[j]}</div>);
    }
    dates_data.push(<div class="weekdays_date clearfix"> {sub_data} </div>);
  }
  this.setState({dates_data});
}

  render() {
    return (
        <>
        {this.state.dates_data}
        </>
    );
  }
}

export default CalendarDates;
